import {getLanguageList} from '@ui/utils/intl/languages';

// Customization (change BE/BG): the shared "Language" option set used by BOTH the
// conversation search filter and the trigger "Language" condition, so they always
// offer the exact same choices. When detection languages are configured, only
// those are offered plus an "All other languages" bucket (other languages and no
// language); otherwise the full language list plus a "No language" bucket.
export const LANGUAGE_OTHER = '__other__';
export const LANGUAGE_NONE = '__none__';

export interface ConversationLanguageOption {
  value: string;
  name: string;
  // present so these options are shape-compatible with the trigger builder's
  // other select-option sources (which may carry an icon/description)
  description?: string;
  image?: string;
}

export function buildConversationLanguageOptions(
  configuredCodes: string[],
): ConversationLanguageOption[] {
  const allLanguages = getLanguageList();
  const nameFor = (code: string) =>
    allLanguages.find(l => l.code === code)?.name ?? code;

  if (configuredCodes.length > 0) {
    return [
      ...configuredCodes.map(code => ({value: code, name: nameFor(code)})),
      {value: LANGUAGE_OTHER, name: 'All other languages'},
    ];
  }

  return [
    ...allLanguages.map(l => ({value: l.code, name: l.name})),
    {value: LANGUAGE_NONE, name: 'No language'},
  ];
}
